import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { TRootState } from "../store/reducers/RootReducer";
import { useDispatch } from "react-redux";

export type AppDispatch = ThunkDispatch<TRootState, any, AnyAction>

const useAppDispatch = () => useDispatch<AppDispatch>()

export default useAppDispatch;
